import Script from 'next/script';
import { ReactNode, useState } from 'react';

import { useReferralInfo } from '@flipster/features/src/shared/referral-code/state';
import { Styles, css } from '@flipster/styled-system/css';
import AppleIcon from '@flipster/ui/assets/svgs/social/ic-apple.svg';
import segment, { ReferralEvent } from '@flipster/utils/segment';

import { authButtonCSSRaw } from '@web/app/[locale]/(web)/_auth/base-styles';
import { useSocialLogin } from '@web/hooks/useSocialLogin';

/*
 * data type
 * {
 *   "authorization": {
 *     "code": "[CODE]",
 *     "id_token": "[ID_TOKEN]",
 *     "state": "[STATE]"
 *   },
 * }
 */

interface Props {
  label?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  css?: Styles;
}

export const ContinueWithApple = ({ label, onClick, disabled, css: cssProps }: Props) => {
  const referralInfo = useReferralInfo();
  const loginHandler = useSocialLogin();
  const [load, setLoad] = useState<boolean>(false);

  const onClickLogin = async () => {
    onClick?.();

    try {
      // https://developer.apple.com/documentation/signinwithapplejs/clientconfigi/usepopup
      await window.AppleID?.auth?.init({
        clientId: 'com.aqx',
        redirectURI: `https://${window.location.hostname}`,
        scope: 'email',
        usePopup: true,
      });
      const data = await window.AppleID?.auth.signIn();
      await loginHandler('APPLE', data.authorization.id_token);
    } catch (err) {
      // oxlint-disable-next-line no-console
      console.error(err);
    }
    segment.track(ReferralEvent.SignInSsoClick, {
      auth_type: 'apple',
      ...referralInfo,
    });
  };

  return (
    <>
      <Script
        id='apple-auth-script'
        src='https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
        onReady={() => setLoad(true)}
      />

      <button
        type='button'
        onClick={onClickLogin}
        disabled={!load || disabled}
        className={css(authButtonCSSRaw, cssProps)}
      >
        <AppleIcon width={20} height={20} />
        {label}
      </button>
    </>
  );
};
